export default "__VITE_ASSET__acc58a10__"